// src/pages/Contact.jsx
import React from 'react';
import Seo from '../components/Seo';
import BreadcrumbJsonLd from '../components/BreadcrumbJsonLd';

import Hero from '../components/Home/Hero';
import SimpleScheduler from '../components/Contact/SimpleScheduler';
import '../components/Contact/SimpleScheduler.css';

export default function ContactPage() {
  return (
    <>
      {/* 1. SEO-meta */}
      <Seo
        title="Contact | Online Growth Club"
        description="Neem contact op met OnlineGrowthClub.nl voor een vrijblijvende groeiscan of adviesgesprek over jouw online strategie."
        path="/contact"
      />

      {/* 2. Breadcrumb hiërarchie */}
      <BreadcrumbJsonLd
        list={[
          { name: 'Home',     item: 'https://onlinegrowthclub.nl/' },
          { name: 'Contact',  item: 'https://onlinegrowthclub.nl/contact' }
        ]}
      />

      {/* 3. Pagina-inhoud */}
      <Hero />
      <SimpleScheduler />
    </>
  );
}
